import { render, staticRenderFns } from "./ScrollTextGradient.vue?vue&type=template&id=53c04c4c&scoped=true"
import script from "./ScrollTextGradient.vue?vue&type=script&lang=js"
export * from "./ScrollTextGradient.vue?vue&type=script&lang=js"
import style0 from "./ScrollTextGradient.vue?vue&type=style&index=0&id=53c04c4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c04c4c",
  null
  
)

export default component.exports